import React from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { isEqual } from 'lodash';

class Export extends React.Component {
  static propTypes = {
    options: PropTypes.array.isRequired
  }

  state = {
    exported: false
  }

  componentDidUpdate(previousProps) {
    if (!isEqual(this.props.options, previousProps.options)) {
      this.setState({ exported: false });
    }
  }

  handleExport = () => {
    this.setState({ exported: true });
  }

  render() {
    const { options, ...props } = this.props;

    return (
      <React.Fragment>
        <span name="export-notification">{this.state.exported ? 'Copied! ' : null}</span>
        <CopyToClipboard text={JSON.stringify(options)} onCopy={this.handleExport}>
          <button {...props}>Export</button>
        </CopyToClipboard>
      </React.Fragment>
    );
  }
}

export default Export;
